<template>
  <!-- 编辑网点 -->
  <div class="page-container">
    <div class="page-top-tool">
      <el-page-header @back="goBack" content="编辑订单"></el-page-header>
    </div>
    <div class="form-layout">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="提现编号：" prop="">
          <div>
            {{ form.cash_no }}
          </div>
        </el-form-item>
        <el-form-item label="合伙人编号" prop="">
          <div>
            {{ form.agent_no }}
          </div>
        </el-form-item>
        <el-form-item label="合伙人姓名" prop="">
          <div>
            {{ form.agent_name }}
          </div>
        </el-form-item>
        <el-form-item label="收款人" prop="user_no">
          <div>
            {{ form.account_num ? JSON.parse(form.account_num).payee_name : "" }}
          </div>
        </el-form-item>
        <el-form-item label="收款人身份证" prop="user_no">
          <div>
            {{ form.account_num ? JSON.parse(form.account_num).payee_cardid : '' }}
          </div>
        </el-form-item>
        <el-form-item label="收款卡号" prop="user_no">
          <div>
            {{ form.account_num ? JSON.parse(form.account_num).payee_acount : '' }}
          </div>
        </el-form-item>
        <el-form-item label="开户行" prop="user_no">
          <div>
            {{ form.account_num ? JSON.parse(form.account_num).payee_bank : '' }}
          </div>
        </el-form-item>
        <el-form-item label="收款人手机号" prop="user_no">
          <div>
            {{ form.account_num ? JSON.parse(form.account_num).payee_phone : '' }}
          </div>
        </el-form-item>
        <el-form-item label="打款信息" prop="user_no">
          <div>
            <div>申请提现金额：{{ form.cash_money }}</div>
            <div>实际打款金额：<el-input v-model="form.payment_amount" size="mini" style="width: 200px;"></el-input></div>
            <div>转账手续费：<el-input v-model="form.service_fee" size="mini" style="width: 200px;"></el-input></div>
            <div>个税扣缴金额：<el-input v-model="form.income_tax" size="mini" style="width: 200px;"></el-input></div>
            <div>实际到账金额：<el-input v-model="form.actual_amount" size="mini" style="width: 200px;"></el-input></div>
          </div>
        </el-form-item>
        <el-form-item label="时间信息" prop="user_no">
          <div>
            <div>申请时间：{{ form.apply_time }}</div>
            <div>审批时间：{{ form.examine_time }}</div>
          </div>
        </el-form-item>
        <el-form-item label="打款状态">
          <el-radio-group v-model="form.payment_sate" size="mini">
            <el-radio-button label="1">待审核</el-radio-button>
            <el-radio-button label="2">待转账</el-radio-button>
            <el-radio-button label="3">已转账</el-radio-button>
            <el-radio-button label="4">驳回</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="打款时间" v-if="form.payment_sate == '3'">
          <el-date-picker v-model="form.payment_time" format="yyyy-MM-dd HH:mm:ss" value-format="timestamp"
            type="datetime" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item v-if="form.payment_sate == '3'" label="打款备注">
          <el-input v-model="form.payment_notes" size="mini" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item v-if="form.payment_sate == '4'" label="驳回原因">
          <el-input v-model="form.payment_fail_notes" size="mini" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitForm('ruleForm')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateStorePage',
  data() {
    return {
      form: {
        id: '',
        cash_no: '',
        agent_name: '',
        agent_no: '',
        account_num: '',
        account_type: '',
        account_notes: '',
        cash_money: 0,
        payment_amount: 0,
        service_fee: 0,
        income_tax: 0,
        actual_amount: 0,
        apply_time: '',
        examine_time: '',
        payment_time: '',
        payment_sate: '',
        payment_notes: '',
        payment_fail_notes: '',
        lastupdate_time: '',
        update_logs: ''
      },
      baseurl: '',
      uploadUrl: '',
      headers: {
        'token': localStorage.getItem('weizhanToken')
      },
      rules: {
      },
      agentInfo: null
    };
  },

  mounted() {
    this.baseurl = this.$baseUrl
    this.uploadUrl = this.$uploadUrl
    const cash = sessionStorage.getItem('updateCash')
    if (cash) {
      this.form = JSON.parse(cash)
      this.queryAgentInfo()
    } else {
      this.$message.warning('参数有误，请重新选择要修改的信息')
      this.$router.push({
        path: '/cash'
      })
    }
  },

  methods: {
    // 查询合伙人
    queryAgentInfo() {
      this.$http({
        method: 'post',
        url: '/agentpersonal/findone',
        params: {
          agent_no: this.form.agent_no
        }
      })
        .then(res => {
          if (res.errno == 0 && res.data.data) {
            this.agentInfo = res.data.data
          } else {

          }
        })
        .catch(err => {
          console.error('操作异常：', err.message);
        })
    },
    goBack() {
      this.$router.back()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getCurrentTime() {
      const now = new Date();

      // 获取年、月、日、时、分、秒
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      // 拼接成指定格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    submitForm(formName) {
      if (!this.agentInfo) {
        this.$message.error('合伙人信息查询失败，请刷新页面')
        return
      }
      if (this.form.payment_sate == '3') {
        if (!this.form.payment_time || this.form.payment_time == '') {
          this.$message.error('请填写打款时间')
          return
        }
        if (!this.form.payment_amount || this.form.payment_amount == '') {
          this.$message.error('请填写实际打款金额')
          return
        }
        if (!this.form.service_fee || this.form.service_fee == '') {
          this.$message.error('请填写转账手续费')
          return
        }
        if (!this.form.income_tax || this.form.income_tax == '') {
          this.$message.error('请填写个税扣缴金额')
          return
        }
        if (!this.form.actual_amount || this.form.actual_amount == '') {
          this.$message.error('请填写实际到账金额')
          return
        }
      }
      if (this.form.payment_sate == '4') {
        if (!this.form.payment_fail_notes || this.form.payment_fail_notes == '') {
          this.$message.error('请填写驳回原因')
          return
        }
      }

      if (this.form.payment_sate == '3') {
        this.$confirm('务必确认是否已完成转款？', '提示', {
          confirmButtonText: '已成功转款',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$confirm('此操作将计入用户账单，是否继续？', '提示', {
            confirmButtonText: '继续提交',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {

            this.$refs[formName].validate((valid) => {
              if (valid) {
                if (this.form.payment_sate == '1') {
                  this.form.payment_time = ''
                } else if (this.form.payment_sate == '2') {
                  this.form.examine_time = this.getCurrentTime()
                } else if (this.form.payment_sate == '3') {
                  this.form.payment_fail_notes = ''
                } else if (this.form.payment_sate == '4') {
                  this.form.payment_amount = ''
                  this.form.service_fee = ''
                  this.form.income_tax = ''
                  this.form.actual_amount = ''
                  this.form.payment_notes = ''
                }
                this.$http({
                  method: 'post',
                  url: '/cash/update',
                  params: {
                    ...this.form,
                    update_time: this.getCurrentTime()
                  }
                })
                  .then(res => {
                    if (res.errno == 0) {
                      this.$message.success('修改成功')
                      if (this.form.payment_sate == '3') {
                        this.updateFinance()
                      }
                    } else {
                      this.$message.error('修改失败')
                    }
                  })
                  .catch(err => {
                    this.$message.error('修改失败，服务端异常')
                    console.error('操作异常：', err.message);
                  })
              } else {
                return false;
              }
            })

          }).catch(() => { })

        }).catch(() => { })
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.form.payment_sate == '1') {
              this.form.payment_time = ''
            } else if (this.form.payment_sate == '2') {
              this.form.examine_time = this.getCurrentTime()
            } else if (this.form.payment_sate == '3') {
              this.form.payment_fail_notes = ''
            } else if (this.form.payment_sate == '4') {
              this.form.payment_amount = 0
              this.form.service_fee = 0
              this.form.income_tax = 0
              this.form.actual_amount = 0
              this.form.payment_notes = ''
            }
            this.$http({
              method: 'post',
              url: '/cash/update',
              params: {
                ...this.form,
                update_time: this.getCurrentTime()
              }
            })
              .then(res => {
                if (res.errno == 0) {
                  this.$message.success('修改成功')
                  if (this.form.payment_sate == '4') {
                    this.updateCashStatus('1')
                  }
                } else {
                  this.$message.error('修改失败')
                }
              })
              .catch(err => {
                this.$message.error('修改失败，服务端异常')
                console.error('操作异常：', err.message);
              })
          } else {
            return false;
          }
        })
      }
    },
    // 更新提现申请状态
    updateCashStatus(status) {
      this.$http({
        method: 'post',
        url: '/agentpersonal/renew',
        params: {
          agent_no: this.form.agent_no,
          apply_status: status
        }
      })
        .then(res => {
          if (res.errno == 0) {
            this.$message.success('用户提现状态已修改')
          } else {
            this.$message.error('用户提现状态失败')
          }
        })
        .catch(err => {
          this.$message.error('用户提现状态，服务端异常')
          console.error('操作异常：', err.message);
        })
    },
    // 更新财务信息
    async updateFinance() {
      let agentInfo = await this.$http({
        method: 'post',
        url: '/agentpersonal/findone',
        params: {
          agent_no: this.form.agent_no
        }
      })
      this.$http({
        method: 'post',
        url: '/agentpersonal/renew',
        params: {
          agent_no: this.form.agent_no,
          balance: parseFloat(agentInfo.data.data.balance) - parseFloat(this.form.cash_money),
          total_amount: parseFloat(this.agentInfo.total_amount) + parseFloat(this.form.cash_money),
          apply_status: '1'
        }
      })
        .then(res => {
          if (res.errno == 0) {
            this.$message.success('提现成功')
            this.goBack()
          } else {
            this.$message.error('提现失败')
          }
        })
        .catch(err => {
          this.$message.error('提现失败，服务端异常')
          console.error('操作异常：', err.message);
        })
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: #fff;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 20px 25px;
  overflow-y: scroll;

  .page-top-tool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }

  .form-layout {
    margin: 30px 0px;
    padding: 10px 30px;
  }
}

/* 修改滚动条样式 */
.page-container::-webkit-scrollbar {
  width: 4px;
}

.page-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.avatar-uploader {
  cursor: pointer;
  position: relative;
  width: 120px;
  height: 120px;
}

.avatar-uploader-icon:hover {
  border-color: #409EFF;
  color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

.prview-pic {
  width: 120px;
  height: 120px;
  display: block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

.cardpic {
  width: 200px;
  height: 100px;
  display: block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}

.desc_images {
  height: 100px;
  border: 1px solid red;
  display: block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
}

.copy-link {
  margin-left: 10px;
  color: #409EFF;
}

.copy-link:hover {
  cursor: pointer;
}
</style>